import {
	goniniBlue,
	goniniGreen,
	goniniOrange,
	goniniRed,
} from "./gonini";

// Hex/rgba only: StatusBox lightens these for dark mode, which named CSS colours break.
const statusSuccess = goniniGreen[700],
	statusSuccessStrong = goniniGreen[800],
	statusProgress = goniniBlue[500],
	statusInfo = goniniBlue[400],
	statusInactive = goniniBlue[200],
	statusUnknown = goniniBlue[300],
	statusWarning = goniniOrange[700],
	statusAttention = goniniOrange[500],
	statusError = goniniRed;

export const getStatusColor = (status) => {
	switch (status.toLowerCase()) {
	case "despatched":
		return statusSuccess;
	case "returned":
		return statusSuccess;
	case "picked":
		return statusProgress;
	case "sent to warehouse":
		return statusProgress;
	case "processed":
		return statusProgress;
	case "processing":
		return statusProgress;
	case "inforeceived":
		return statusInfo;
	case "intransit":
	case "in transit":
		return statusProgress;
	case "outfordelivery":
		return statusProgress;
	case "transit":
		return statusProgress;
	case "pickup":
		return statusProgress;
	case "delivered":
		return statusSuccess;
	case "attemptfail":
	case "attempt failed":
		return statusError;
	case "exception":
		return statusError;
	case "cancelled":
		return statusInactive;
	case "pending":
		return statusInactive;
	case "expired":
		return statusInactive;
	case "new":
		return statusProgress;
	case "held":
		return statusProgress;
	case "onbackorder":
		return statusWarning;
	case "label created":
		return statusAttention;
	case "fraudrisk":
		return statusError;
	case "awaitingconfirmation":
		return statusError;
	case "error processing report":
		return statusError;
	case "ready to download":
		return statusSuccess;
	case "notscanned":
		return statusAttention;
	case "draft":
		return statusWarning;
	case "awaitingscan":
		return statusAttention;
	case "lostnotscanned":
		return statusError;
	case "lostintransit":
		return statusError;
	case "stalledintransit":
		return statusError;
	case "returningtosender":
		return statusError;
	case "availableforcustomercollection":
		return statusSuccess;
	case "awaitingdelivery":
		return statusError;
	case "bookedin":
		return statusSuccess;
	case "uploadpending":
		return statusWarning;
	default:
		return statusUnknown;
	}
};

export const getClaimsStatusColor = (status) => {
	switch (status.toLowerCase()) {
	case "unsuccessful":
		return statusError;
	case "in progress":
		return statusWarning;
	case "successful":
		return statusSuccess;
	default:
		return statusUnknown;
	}
};

export const getASNStatusColor = (status) => {
	switch (status.toLowerCase()) {
	case "delivered":
		return statusProgress;
	case "awaitingdelivery":
		return statusError;
	case "partiallybooked":
		return statusAttention;
	case "bookedin":
		return statusSuccessStrong;
	case "bookedin-partial":
		return statusSuccess;
	case "new":
		return statusProgress;
	case "uploadpending":
		return statusProgress;
	case "complete":
		return statusSuccess;
	case "draft":
		return statusWarning;
	default:
		return statusUnknown;
	}
};

export const getASNStatusLabel = (status) => {
	switch (status.toLowerCase()) {
	case "awaitingdelivery":
		return "Awaiting Delivery";
	case "bookedin":
		return "Booked In";
	case "partiallybooked":
		return "Partially Booked";
	case "bookedin-partial":
		return "Booked In Partial";
	case "delivered":
		return "Delivered";
	case "cancelled":
		return "Cancelled";
	case "draft":
		return "Draft";
	case "new":
		return "New";
	case "complete":
		return "Complete";
	case "uploadpending":
		return "Upload Pending";
	default:
		return status.toLowerCase();
	}
};

export const getASNDeliverySlotStatusLabel = (item) => item;

export const getASNDeliverySlotStatusColor = (status) => {
	switch (status.toLowerCase()) {
	case "required":
		return statusError;
	case "pending":
		return statusProgress;
	case "requested":
		return statusProgress;
	case "approved":
		return statusSuccess;
	case "n/a":
		return statusUnknown;
	default:
		return statusUnknown;
	}
};

export const getInventoryStatusColor = (status) => {
	switch (status.toLowerCase()) {
	case "active":
		return statusSuccess;
	case "pending":
		return statusProgress;
	case "awaitingverification":
		return statusAttention;
	case "rejected":
		return statusError;
	case "undefined":
		return statusInactive;
	case "uploadpending":
			return statusWarning;
	case "hidden":
			return statusUnknown;
	default:
		return statusUnknown;
	}
};

export const getOrderStatusLabel = (status) => {
	switch (status.toLowerCase()) {
	case "new":
		return "New";
	case "onbackorder":
		return "On back order";
	case "fraudrisk":
		return "Fraud risk";
	case "awaitingconfirmation":
		return "Awaiting confirmation";
	case "despatched":
		return "Despatched";
	case "processed":
		return "Processed";
	case "processing":
		return "Processing";
	case "returned":
		return "Returned";
	case "delivered":
		return "Delivered";
	case "cancelled":
		return "Cancelled";
	case "pending":
		return "Pending";
	case "availableforpickup":
		return "Available for pickup";
	case "picked":
		return "Picked";
	case "held":
		return "On hold";
	case "sent to warehouse":
		return "Sent to warehouse";
	case "uploadpending":
		return "Upload Pending";	
	default:
		return status.toLowerCase();
	}
};

export const getCourierStatusLabel = (status) => {
	if (!status) {
		return "Unknown";
	}
	switch (status.toLowerCase()) {
	case "inforeceived":
		return "Info received";
	case "intransit":
		return "In transit";
	case "transit":
		return "In transit";
	case "outfordelivery":
		return "Out for delivery";
	case "pickup":
		return "Out for delivery";
	case "delivered":
		return "Delivered";
	case "attemptfail":
		return "Failed attempt";
	case "exception":
		return "Exception";
	case "pending":
		return "Pending";
	case "expired":
		return "Expired";
	case "availableforpickup":
		return "Available for pickup";
	case "notscanned":
		return "Not scanned";
	case "awaitingscan":
		return "Awaiting scan";
	case "returningtosender":
		return "Returning to sender";
	case "availableforcustomercollection":
		return "Available for customer collection";
	case "lostnotscanned":
		return "Lost not scanned";
	case "lostintransit":
		return "Lost in transit";
	case "stalledintransit":
		return "Stalled in transit";
	case "unknown":
		return "Unknown";
	default:
		return status.toLowerCase();
	}
};

export const getReportStatusLabel = (status) => {
	switch (status.toLowerCase()) {
	case "processing":
		return "Processing";
	case "ready to download":
		return "Ready to download";
	case "error processing report":
		return "Error processing report";
	default:
		return status.toLowerCase();
	}
};

export const productStatusPending = "pending",
	productStatusRejected = "rejected",
	productStatusActive = "active",
	productStatusAwaitingVerification = "awaitingverification",
	productStatusUndefined = "undefined";

export const getInventoryStatusLabel = (status) => {
	switch (status.toLowerCase()) {
	case productStatusActive:
		return "Active";
	case productStatusPending:
		return "Pending";
	case productStatusAwaitingVerification:
		return "Awaiting Verification";
	case productStatusRejected:
		return "Rejected";
	case "uploadpending":
		return "Upload Pending";			
	case productStatusUndefined:
		return "Undefined";
	default:
		return status.toLowerCase();
	}
};
